import "pixi";
import "phaser";

import * as i18n from "./i18n";

export class Overlay {
    game: Phaser.Game;
    group: Phaser.Group;
    victoryPopup: Popup;
    deathPopup: Popup;

    constructor(game: Phaser.Game, group: Phaser.Group) {
        this.game = game;
        this.group = group;

        this.victoryPopup = new Popup(this.game, this.group, i18n._("Level Complete"), "", 400, 300);
        this.deathPopup = new Popup(this.game, this.group, i18n._("You Died"), "", 400, 300);
    }

    victory(message: string, star: Phaser.Sprite | null, callback: Function) {
        const showPopup = (): Phaser.Tween => {
            this.victoryPopup.setSubtitle(message);
            this.victoryPopup.callback = callback;
            return this.victoryPopup.fadeIn(300);
        };
        if (star) {
            const xc = (star.x < this.game.width / 2) ? (3 * this.game.width / 4) : (this.game.width / 4);
            const yc = this.game.height / 2;
            const x2 = this.game.width / 2;
            const y2 = this.game.height / 4;

            const emitter = this.game.add.emitter(x2, y2, 10);
            emitter.makeParticles("victory-star");
            emitter.minParticleSpeed.setTo(-1000, -1000);
            emitter.maxParticleSpeed.setTo(1000, 1000);
            emitter.minParticleScale = 0.2;
            emitter.maxParticleScale = 0.5;

            const victoryStar = this.game.add.sprite(star.x, star.y, "victory-star");
            victoryStar.alpha = 0;
            victoryStar.width = star.width;
            victoryStar.height = star.width * (70 / 73);
            victoryStar.anchor.setTo(0.5, 0.25);

            this.game.add.tween(star.scale).to({
                x: 2,
                y: 2,
            }, 300).start();
            this.game.add.tween(victoryStar).to({
                alpha: 1,
            }, 400).delay(200).start();
            this.game.add.tween(star).to({
                alpha: 0,
            }, 400).delay(200).start();

            const syncStars = () => {
                victoryStar.position.copyFrom(star.position);
                victoryStar.width = star.width;
                victoryStar.height = star.width * (70 / 73);
            };

            // http://www.html5gamedevs.com/topic/5048-tween-along-custom-paths/
            const tween = this.game.add.tween(star).to({
                // https://stackoverflow.com/questions/6711707
                x: [star.x, 2 * xc - star.x / 2 - x2/2, x2],
                y: [star.y, 2 * yc - star.y / 2 - y2/2, y2],
            }, 600).interpolation(function(v: number[], k: number): number {
                return Phaser.Math.bezierInterpolation(v, k);
            }).onUpdateCallback(syncStars).start();
            tween.onComplete.add(syncStars);
            tween.onComplete.add(() => {
                emitter.start(true, 1500, 0, 30);
            });

            this.game.time.events.add(600, () => {
                showPopup().onComplete.add(() => {
                    this.game.add.tween(victoryStar).to({
                        x: this.game.width / 2,
                        y: -100,
                    }, 300, Phaser.Easing.Cubic.In).delay(300).start();
                    this.game.add.tween(victoryStar.scale).to({
                        x: 0.5,
                        y: 0.5,
                    }, 300).delay(300).start();
                });
            });
        }
        else {
            showPopup();
        }
    }

    victorySkip() {
        this.victoryPopup.callback();
    }

    death(reason: string, callback: Function) {
        this.deathPopup.setSubtitle(reason);
        this.game.time.events.add(300, () => {
            this.deathPopup.fadeIn(300);
            this.deathPopup.callback = callback;
        });
    }
}


class Popup {
    game: Phaser.Game;
    group: Phaser.Group;

    container: Phaser.Group;
    text: i18n.Text;
    subtitle: i18n.Text;
    background: Phaser.Graphics;

    callback: Function;

    constructor(game: Phaser.Game, group: Phaser.Group, text: string, subtitle: string, x: number, y: number) {
        this.game = game;
        this.group = group;

        this.container = this.game.add.group(this.group);
        this.container.position.setTo(x, y);

        this.background = this.game.add.graphics(-this.game.width / 2, -52, this.container);
        this.text = i18n.label(this.game, 0, 0, text, "font-large", 96);
        this.subtitle = i18n.label(this.game, 0, 96, subtitle, "font-small", 42);
        this.container.add(this.text);
        this.container.add(this.subtitle);

        this.text.anchor.setTo(0.5, 0.5);
        this.text.align = "center";
        this.subtitle.anchor.setTo(0.5, 0.5);
        this.subtitle.align = "center";

        this.container.alpha = 0;
        this.background.beginFill(0x000000);
        this.background.drawRect(0, 0, this.game.width, 104);
        this.background.alpha = 0.5;
    }

    fadeIn(fadeTime: number): Phaser.Tween {
        this.subtitle.alpha = 0.0;
        const fadeIn = this.game.add.tween(this.container).to({
            alpha: 1,
        }, fadeTime, Phaser.Easing.Cubic.Out);
        const subtitleFade = this.game.add.tween(this.subtitle).to({
            alpha: 1,
        }, fadeTime, Phaser.Easing.Cubic.Out).delay(fadeTime);

        (this.subtitle.text ? subtitleFade : fadeIn).onComplete.add(() => {
            this.fadeOut();
        });
        fadeIn.start();
        subtitleFade.start();
        return fadeIn;
    }

    fadeOut() {
        const fadeOut = this.game.add.tween(this.container).to({
            alpha: 0,
        }, 300, Phaser.Easing.Cubic.Out).delay(300);
        fadeOut.onComplete.add(() => {
            this.callback();
        });
        fadeOut.start();
        return fadeOut;
    }

    setSubtitle(text: string) {
        this.subtitle.text = text;
    }
}



// WEBPACK FOOTER //
// ./src/overlay.ts